const purple = {
  25: "#FAFAFF",
  50: "#F4F3FF",
  100: "#EBE9FE",
  200: "#D9D6FE",
  300: "#BDB4FE",
  400: "#9B8AFB",
  500: "#7A5AF8",
  600: "#6938EF",
  700: "#5925DC",
  800: "#4A1FB8",
  900: "#3E1C96",
  950: "#27115F",
};

export default purple;
